<div id="Appcontainer">

<ngx-loading-bar [color]="'#141414'" [includeSpinner]="false" [height]="'3px'"></ngx-loading-bar>
<app-loader></app-loader>
<app-tap-to-top></app-tap-to-top>
<app-navigathion *ngIf="!isLogin"></app-navigathion>
 <router-outlet></router-outlet>
    
</div>